(() => {
  const initialize = (root) => {
    if (root.dataset.ingredientsReady) return;
    const body = root.querySelector('[data-ingredient-body]');
    const headings = [...body.querySelectorAll(':scope > h4')];
    if (!headings.length) return;
    root.dataset.ingredientsReady = 'true';
    const entries = headings.map((heading, index) => {
      const entry = document.createElement('section');
      entry.className = 'ingredient-entry';
      entry.id = `${root.dataset.sectionId}-ingredient-${index}`;
      heading.before(entry);
      let node = heading;
      while (node && (node === heading || !(node.nodeType === 1 && node.tagName === 'H4'))) {
        const next = node.nextSibling;
        entry.append(node);
        node = next;
      }
      return { entry, title: heading.textContent.trim(), text: entry.textContent.toLocaleLowerCase() };
    });
    // Sanitized import lost its source IDs; replace only its broken source alphabet links.
    body.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.hostname === 'naturium.com' && url.pathname === '/' && url.hash) link.remove();
    });
    const controls = root.querySelector('.ingredient-controls');
    const alphabet = controls.querySelector('[data-ingredient-letters]');
    const letters = new Map();
    const letterFor = (title) => /[A-Z]/.test(title.charAt(0).toUpperCase()) ? title.charAt(0).toUpperCase() : '#';
    entries.forEach((item) => { if (!letters.has(letterFor(item.title))) letters.set(letterFor(item.title), item.entry); });
    [...letters.keys()].sort((a,b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b)).forEach((letter) => {
      const link = document.createElement('a');
      link.textContent = letter;
      link.href = `#${letters.get(letter).id}`;
      alphabet.append(link);
    });
    const status = controls.querySelector('[data-ingredient-status]');
    controls.querySelector('[data-ingredient-search]').addEventListener('input', (event) => {
      const query = event.target.value.trim().toLocaleLowerCase();
      let count = 0;
      entries.forEach((item) => { item.entry.hidden = !item.text.includes(query); if (!item.entry.hidden) count++; });
      for (const link of alphabet.children) {
        const target = entries.find((item) => !item.entry.hidden && letterFor(item.title) === link.textContent);
        link.hidden = !target;
        if (target) link.href = `#${target.entry.id}`;
      }
      status.textContent = `${count} ingredients`;
    });
    status.textContent = `${entries.length} ingredients`;
    controls.hidden = false;
  };
  document.querySelectorAll('[data-ingredient-library]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ingredient-library]').forEach(initialize));
})();
